import React from 'react';
import SimpleDialog, { SimpleDialogProps } from '../SimpleDialog/SimpleDialog';
import { Button } from '../../ui';
import { PaperStatus, PaperStatusName } from '../../../store/paper-status/types';
import { AppState } from '../../../store/state';
import { selectPaperStatusState } from '../../../store/selectors';
import { AppDispatch } from '../../../store/store';
import { connect } from 'react-redux';
import { updatePaperStatusBulkDTO } from '../../../store/info/types';
import submissionSlice from '../../../store/submission/slice';
import { useTranslation } from 'react-i18next';
import { Role } from '../../../store/conference/types';

interface Props extends SimpleDialogProps {
  initialOption?: string;
  submissionIds: number[];
  paperStatusById: { [key: number]: PaperStatus };
  updatePaperStatusBulkAction: (data: updatePaperStatusBulkDTO) => void;
  role: Role;
}

const PaperStatusChangeDialogMobile: React.FC<Props> = ({
  initialOption,
  submissionIds,
  paperStatusById,
  updatePaperStatusBulkAction,
  role,
  ...rest
}) => {
  const { t } = useTranslation();
  const [selectedOption, setSelectedOption] = React.useState<string | undefined>(initialOption);

  const getOptions = (role: Role) => {
    let options: { id: string; label: string; category: string }[];
    switch (role.type) {
      case 'reviewer':
      case 'chair':
        options = Object.values(paperStatusById)
          .filter((paperStatus) => !(['Deleted'] as PaperStatusName[]).includes(paperStatus.name))
          .map((value) => ({ id: value.id.toString(), label: value.name, category: value.category }));
        break;
      default:
        options = [];
    }
    return options;
  };

  const getStatusClass = (category: string): string | undefined => {
    let statusClass;

    if (category === 'in_progress') {
      statusClass = 'mobileCtrlAwaiting';
    } else if (category === 'rejection') {
      statusClass = 'mobileCtrlRejected';
    } else if (category === 'accepted') {
      statusClass = 'mobileCtrlAccepted';
    }

    return statusClass;
  };

  return (
    <SimpleDialog {...rest} title={t('Edit paper status')}>
      <div className="flex flex-col gap-3 mobileCtrlEditPaperStatusWrapper">
        {Object.values(getOptions(role)).map((option, index) => {
          return (
            <Button
              key={index}
              className={`mobileCtrlPaperStatusOptionButton ${getStatusClass(option.category) ?? ''} ${
                option.id === selectedOption ? 'selected' : ''
              }`}
              onClick={() => {
                setSelectedOption(option.id);
                updatePaperStatusBulkAction({
                  submissionIds,
                  paper_status_id: parseInt(option.id),
                });
                rest.handleClose?.();
              }}
            >
              {option.label}
            </Button>
          );
        })}
      </div>
    </SimpleDialog>
  );
};

const mapStateToProps = (state: AppState) => ({
  paperStatusById: selectPaperStatusState(state).paperStatusById,
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  updatePaperStatusBulkAction: (data: updatePaperStatusBulkDTO) =>
    dispatch(submissionSlice.actions['UPDATE:PAPER-STATUS:BULK'](data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PaperStatusChangeDialogMobile);
